module.exports = __webpack_public_path__ + "img/img_career_sean_kan_L@2x.87f97f24.png";